import type { ReactElement } from "react";
import type { LotAnalysisReportData } from "../createPropertyReport";
import type { InspectorPresentation } from "./BaseLayersCard";
import {
  InspectorChipButton,
  InspectorChipButtonRow
} from "./InspectorChipButton";
import { Spacer } from "../Spacer";
import { buildMeasurementRows } from "./measurementsRows";
import { SidetextRow, SidetextSideText } from "./SidetextRow";

export interface MeasurementsLayersCardProps {
  lot: LotAnalysisReportData | null;
  presentation?: InspectorPresentation;
  /** Interactive tape measure — omitted in contexts without a live scene
   *  (e.g. the handset sheet, where pick-on-canvas isn't reachable). */
  measureActive?: boolean;
  onMeasureToggle?: () => void;
}

export function MeasurementsLayersCard({
  lot,
  presentation = "inspector",
  measureActive = false,
  onMeasureToggle
}: MeasurementsLayersCardProps): ReactElement {
  const drawerRail = presentation === "drawer";

  if (lot == null) {
    return (
      <SidetextSideText>
        Measurements appear after lot analysis finishes loading.
      </SidetextSideText>
    );
  }

  return (
    <div>
      {buildMeasurementRows(lot).map((r) => (
        <SidetextRow
          key={r.key}
          label={r.label}
          sideText={r.value}
          drawerRail={drawerRail}
        />
      ))}
      {onMeasureToggle ? (
        <>
          <Spacer size="xs" noBorder />
          <InspectorChipButtonRow>
            <InspectorChipButton
              drawerRail={drawerRail}
              onClick={onMeasureToggle}
              aria-pressed={measureActive}
            >
              {measureActive ? "Done measuring" : "Measure distance"}
            </InspectorChipButton>
          </InspectorChipButtonRow>
        </>
      ) : null}
    </div>
  );
}
